const mediaItems = [
  {
    title: '97视频平台速览',
    desc: '快速了解97视频的核心功能与特色内容分类',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20concept%20with%20warm%20dark%20theme%2C%20cinematic%20video%20player%20UI%20mockup%2C%20sleek%20minimal%20design%20with%20amber%20accents%2C%20premium%20digital%20entertainment&width=800&height=450&seq=media-97&orientation=landscape',
    duration: '5分钟速览',
  },
  {
    title: '丝瓜视频功能演示',
    desc: '演示丝瓜视频的界面布局与核心操作流程',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20app%20interface%20with%20soft%20green%20accents%2C%20video%20browsing%20screen%20mockup%2C%20minimalist%20mobile%20UI%20design%2C%20fresh%20youthful%20aesthetic&width=800&height=450&seq=media-sigua&orientation=landscape',
    duration: '4分钟演示',
  },
  {
    title: '蓝莓视频内容探索',
    desc: '浏览蓝莓视频的独家内容库与分类体系',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20content%20library%20interface%2C%20grid%20layout%20with%20thumbnail%20cards%2C%20premium%20streaming%20catalog%20design%2C%20warm%20ambient%20lighting%2C%20luxurious%20digital%20feel&width=800&height=450&seq=media-lanmei&orientation=landscape',
    duration: '6分钟探索',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            平台演示
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            平台速览演示
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            图文预览各在线视频平台的核心界面与功能亮点
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-video">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-100 text-[10px] whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}